var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "220 0 410.25 50.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.5,12.19c11.08,0,11.8,9.87,11.8,9.87h-6.74s-.24-4.82-5.06-4.82c-4.28,0-5.78,3.66-5.78,8.19s1.5,8.19,5.78,8.19c4.82,0,5.06-4.82,5.06-4.82h6.74s-.72,9.87-11.8,9.87c-8.18,0-12.52-5.92-12.52-13.24S237.32,12.19,245.5,12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.94,38h-6.5V33.86h-.24a8.7,8.7,0,0,1-7.71,4.81c-7,0-8.91-4.57-8.91-10.35V12.91h6.74v14c0,4.34,1.21,6.27,4.34,6.27,3.61,0,5.54-2.17,5.54-7.23v-13h6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.85,22.78C286.85,4.24,294.51,0,301.49,0h9.2V5.54h-9.78c-5.44,0-8.28,3.85-8.28,11.94h.24s2.17-3.85,7.94-3.85c7.47,0,11.8,5.54,11.8,12.52,0,6.74-4.33,12.52-12.76,12.52C293.11,38.67,286.85,34.82,286.85,22.78Zm13,10.84c4.29,0,6-3.42,6-7.47s-1.73-7.46-6-7.46-6,3.42-6,7.46S295.57,33.62,299.85,33.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.51,38H332V33.86h-.24a8.7,8.7,0,0,1-7.71,4.81c-7,0-8.91-4.57-8.91-10.35V12.91h6.74v14c0,4.34,1.21,6.27,4.34,6.27,3.61,0,5.54-2.17,5.54-7.23v-13h6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.47,12.91H348v3.37h.24a8.73,8.73,0,0,1,7.71-4.09c7.22,0,10.84,6.26,10.84,13.24s-3.62,13.24-10.84,13.24c-5.3,0-7.46-3.37-7.46-3.37h-.25V50.86h-6.74ZM354,33.62c4.1,0,6-3.66,6-8.19s-1.92-8.19-6-8.19-6,3.66-6,8.19S349.9,33.62,354,33.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.57,12.19c11.08,0,11.8,9.87,11.8,9.87h-6.74s-.24-4.82-5.06-4.82c-4.28,0-5.78,3.66-5.78,8.19s1.5,8.19,5.78,8.19c4.82,0,5.06-4.82,5.06-4.82h6.74s-.72,9.87-11.8,9.87c-8.18,0-12.52-5.92-12.52-13.24S373.39,12.19,381.57,12.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.28,12.91H403V23l8.91-10.11h7.95l-9.44,9.77L420.36,38h-8.23L405.77,27.5,403,30.34V38h-6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M445.24,38h-6.5V33.86h-.24a8.7,8.7,0,0,1-7.71,4.81c-7,0-8.91-4.57-8.91-10.35V12.91h6.74v14c0,4.34,1.21,6.27,4.34,6.27,3.61,0,5.54-2.17,5.54-7.23v-13h6.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.16,12.19c8.23,0,12,5.92,12,13.24,0,.58-.05,1.44-.05,1.44H455.42c.29,3.86,1.93,6.75,6,6.75a4.84,4.84,0,0,0,4.81-3.86H473s-1.45,8.91-11.8,8.91c-8.43,0-12.53-5.92-12.53-13.24S452.92,12.19,461.16,12.19Zm-5.54,10.35h10.64c-.43-3.08-1.78-5.3-5.1-5.3S456.2,19.46,455.62,22.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.9,24.53a6.31,6.31,0,0,0-.07-.76c0-.26-.06-.51-.1-.77-.69-4.4-3.35-6.88-8.22-6.88a7.61,7.61,0,0,0-6.42,3.05V16.69h-2.24V41h2.43V31.88a7.62,7.62,0,0,0,6.23,2.8c5.46,0,8.16-3.24,8.39-8.47a.5.5,0,0,0,0-.17c0-.21,0-.4,0-.6v0C534.93,25.12,534.92,24.82,534.9,24.53Zm-15.11.91v-.09c0-4.43,2.22-8,6.81-8,4.29,0,6.48,3.11,6.78,7.11v.09c0,.19,0,.4,0,.59s0,.16,0,.24a0,0,0,0,1,0,0l0,0c0,4.48-2.19,8.09-6.82,8.09S519.79,29.92,519.79,25.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M534.83,23.77a4.91,4.91,0,0,0-.1-.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M550.78,30a6.23,6.23,0,0,1-5.47,3.05c-2,0-6.45-.84-6.86-6.43l-.1-1.28h15.1c0-5.78-3.13-9.23-8.33-9.23-6.42,0-8.7,4.79-8.7,9.28,0,5.81,3.25,9.28,8.7,9.28,5,0,7-2.88,7.73-4.67Zm-5.66-12.27c6.21,0,6.21,6,6.21,6h-13S538.34,17.74,545.12,17.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "571.63 34.11 571.63 16.69 569.52 16.69 569.52 24.49 558.03 24.49 558.03 16.69 555.92 16.69 555.92 34.11 558.03 34.11 558.03 26.3 569.52 26.3 569.52 34.11 571.63 34.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.66,17.26c-6.41,0-7.64,3.65-7.64,3.65,0-6.51,3.07-9.29,7.71-9.29h6.54V9.84h-6.08c-5.13,0-10.38,1.6-10.38,13.47,0,9.39,4.94,11.37,9.09,11.37,6.56,0,8.89-4.69,8.89-8.71C515.79,21.64,513.28,17.26,507.66,17.26Zm-.76,15.8c-4.49,0-7.28-2.72-7.28-7.09s2.79-7.08,7.28-7.08,7.27,2.71,7.27,7.08S511.39,33.06,506.9,33.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M599.05,23.92h-3.47V16.69h-2.14V34.11h5.61c4.69,0,7.37-1.86,7.37-5.1S603.74,23.92,599.05,23.92Zm-.76,8.76h-2.71V25.35h2.71c1.28,0,6.54-.47,6.54,3.66S599.57,32.68,598.29,32.68Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 608.12,
    y: 16.69,
    width: 2.14,
    height: 17.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 573.33,
    y: 32.29,
    width: 18.17,
    height: 1.81
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "582.42 16.69 580.52 16.69 574.14 34.11 576.33 34.11 581.86 17.94 582.42 17.94 582.42 16.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "582.42 16.69 584.32 16.69 590.7 34.11 588.51 34.11 582.98 17.94 582.42 17.94 582.42 16.69"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logoShort.a0b62089e0ddfcdda4c06d84efc71a8a.svg";
export { ForwardRef as ReactComponent };